import script from "./juese.vue?vue&type=script&setup=true&lang=ts"
export * from "./juese.vue?vue&type=script&setup=true&lang=ts"

import "./juese.vue?vue&type=style&index=0&id=0c87134a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c87134a"]])

export default __exports__